import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, CardContent } from "../ui/card";

const data = [
  { year: '2010', 'Longo Curso': 621.5, 'Cabotagem': 181.4, 'Interior': 28.5 },
  { year: '2011', 'Longo Curso': 655.8, 'Cabotagem': 193.3, 'Interior': 30.8 },
  { year: '2012', 'Longo Curso': 671.9, 'Cabotagem': 197.6, 'Interior': 31.7 },
  { year: '2013', 'Longo Curso': 685.2, 'Cabotagem': 207.1, 'Interior': 36.1 },
  { year: '2014', 'Longo Curso': 736.9, 'Cabotagem': 219.0, 'Interior': 40.0 },
  { year: '2015', 'Longo Curso': 792.8, 'Cabotagem': 210.8, 'Interior': 38.4 },
  { year: '2016', 'Longo Curso': 767.1, 'Cabotagem': 216.5, 'Interior': 41.5 },
  { year: '2017', 'Longo Curso': 831.6, 'Cabotagem': 225.9, 'Interior': 57.0 },
  { year: '2018', 'Longo Curso': 837.2, 'Cabotagem': 226.7, 'Interior': 60.6 },
  { year: '2019', 'Longo Curso': 805.1, 'Cabotagem': 233.0, 'Interior': 66.8 },
  { year: '2020', 'Longo Curso': 851.3, 'Cabotagem': 258.9, 'Interior': 67.2 },
  { year: '2021', 'Longo Curso': 878.7, 'Cabotagem': 291.5, 'Interior': 69.4 },
  { year: '2022', 'Longo Curso': 870.2, 'Cabotagem': 290.0, 'Interior': 78.4 },
  { year: '2023', 'Longo Curso': 920.0, 'Cabotagem': 288.7, 'Interior': 83.1 },
  { year: '2024', 'Longo Curso': 949.5, 'Cabotagem': 293.8, 'Interior': 76.3 },
];

export default function NavigationTypeChart() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Ticks mais limpos no mobile; garante último ano
  const yearTick = (value, index) => {
    const yr = parseInt(value, 10);
    if (isMobile) {
      const isLast = index === data.length - 1;
      // mostra de 2 em 2 anos + último
      if (yr % 2 === 0 || isLast) return `'${String(yr).slice(2)}`;
      return '';
    }
    return value;
  };

  return (
    <Card>
      <CardContent className="p-2 pt-6">
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart
            data={data}
            margin={{ top: 8, right: 12, bottom: 0, left: -6 }}
          >
            <defs>
              <linearGradient id="colorLongo" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#0369a1" stopOpacity={0.85}/>
                <stop offset="95%" stopColor="#0369a1" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorCabotagem" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#0891b2" stopOpacity={0.85}/>
                <stop offset="95%" stopColor="#0891b2" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorInterior" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#a855f7" stopOpacity={0.85}/>
                <stop offset="95%" stopColor="#a855f7" stopOpacity={0}/>
              </linearGradient>
            </defs>

            <XAxis
              dataKey="year"
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              tickFormatter={yearTick}
              interval={0} // renderiza todos; o formatter esconde alguns no mobile
            />
            <YAxis
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              tickFormatter={(v) => `${v}M`}
              width={isMobile ? 30 : 40}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }} // remove a faixa cinza
              contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(5px)',
                border: '1px solid #ddd',
                borderRadius: '0.5rem'
              }}
            />
            <Legend
              wrapperStyle={{ fontSize: '12px' }}
              iconSize={10}
              verticalAlign="bottom"
              height={28}
            />

            <Area
              type="monotone"
              dataKey="Longo Curso"
              stroke="#0369a1"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorLongo)"
              dot={false}
              activeDot={{ r: 3 }}
            />
            <Area
              type="monotone"
              dataKey="Cabotagem"
              stroke="#0891b2"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorCabotagem)"
              dot={false}
              activeDot={{ r: 3 }}
            />
            <Area
              type="monotone"
              dataKey="Interior"
              stroke="#a855f7"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorInterior)"
              dot={false}
              activeDot={{ r: 3 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
